module.exports = __webpack_public_path__ + "04_long_black.b9f0e714.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_long_black.png
// module id = CjrP
// module chunks = 0